// a react component to inject the returned html
import React, { Component } from "react";
import "whatwg-fetch";
import config from  '../../config';

export default class StaticPageContent extends Component {
    constructor(props) {
        super(props)
         this.state = {
            __html: ""
        }
    }

    componentWillMount() {
        // fetch the HTML fragment with a local API request
        console.log('before fetch', this.props  );

        fetch(config.getEnvironment().serverBaseURL +'/static/'+this.props.pageName+'_page')
            .then(resp => {
                console.log('resp',  resp  );
                // fetch returns a readable stream, so translate it into stringified HTML
                return resp.text();
            })
            .then(content => {
                // dangerouslySetInnerHTML requires using an object with an `__html` key
                this.setState({
                    __html: content
                });
            })
            .catch(err => {
                // handle the error
            });
    }

    render() {
        return (
            <div dangerouslySetInnerHTML={this.state} />
        );
    }
}